/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmitPalAuthSubmissionRequest
 */
export interface SubmitPalAuthSubmissionRequest {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SubmitPalAuthSubmissionRequest
     */
    submission_form_data?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof SubmitPalAuthSubmissionRequest
     */
    upload_to_platform?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubmitPalAuthSubmissionRequest
     */
    include_lead_summary_report?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubmitPalAuthSubmissionRequest
     */
    comment?: string;
}

/**
 * Check if a given object implements the SubmitPalAuthSubmissionRequest interface.
 */
export function instanceOfSubmitPalAuthSubmissionRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SubmitPalAuthSubmissionRequestFromJSON(json: any): SubmitPalAuthSubmissionRequest {
    return SubmitPalAuthSubmissionRequestFromJSONTyped(json, false);
}

export function SubmitPalAuthSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitPalAuthSubmissionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'submission_form_data': !exists(json, 'submission_form_data') ? undefined : json['submission_form_data'],
        'upload_to_platform': !exists(json, 'upload_to_platform') ? undefined : json['upload_to_platform'],
        'include_lead_summary_report': !exists(json, 'include_lead_summary_report') ? undefined : json['include_lead_summary_report'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function SubmitPalAuthSubmissionRequestToJSON(value?: SubmitPalAuthSubmissionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'submission_form_data': value.submission_form_data,
        'upload_to_platform': value.upload_to_platform,
        'include_lead_summary_report': value.include_lead_summary_report,
        'comment': value.comment,
    };
}

